import { jsx as e } from "react/jsx-runtime";
function t(C) {
  return /* @__PURE__ */ e("svg", { height: "50", viewBox: "0 0 50 50", width: "50", ...C, children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e(
    "path",
    {
      clipRule: "evenodd",
      d: "M37.852 14.3935C39.1906 14.7539 40.246 15.8093 40.6063 17.1478C41.2756 19.5675 41.2499 24.6643 41.2499 24.6643C41.2499 24.6643 41.2499 29.7353 40.6063 32.1807C40.246 33.5193 39.1906 34.5747 37.852 34.935C35.4066 35.5786 25.6249 35.5786 25.6249 35.5786C25.6249 35.5786 15.8433 35.5786 13.3978 34.935C12.0593 34.5747 11.0039 33.5193 10.6435 32.1807C10 29.7611 10 24.6643 10 24.6643C10 24.6643 10 19.5933 10.6435 17.1478C11.0039 15.8093 12.0593 14.7539 13.3978 14.3935C15.8433 13.75 25.6249 13.75 25.6249 13.75C25.6249 13.75 35.4066 13.75 37.852 14.3935ZM22.5102 19.9794V29.3492L30.6187 24.6643L22.5102 19.9794Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ) }) });
}
export {
  t as default
};
